import { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { PageHeader } from 'app/components/ui/page-header'
import type { TabType } from 'app/components/Tabs'
import { PAGE_GUTTER, PageGutterContext } from 'app/components/layout/PageScroll'
import { cn } from 'app/lib/utils'

export type IntegrationsLayoutShadcnComponentProps = {
  tabs: TabType[]
  primaryButtonSlot: React.ReactElement
}

export function IntegrationsLayoutShadcnComponent({ tabs, primaryButtonSlot }: IntegrationsLayoutShadcnComponentProps) {
  const gutter = PAGE_GUTTER[useContext(PageGutterContext)]
  return (
    <div className="flex h-full flex-col">
      <div className={cn(`shrink-0 pt-8`, gutter)}>
        <PageHeader title="Integrations" primaryButtonSlot={primaryButtonSlot} tabs={tabs} />
      </div>
      <div className="min-h-0 grow pt-4">
        <Outlet />
      </div>
    </div>
  )
}
